import { hsaPayoutReportSettingsSchema } from "@redotech/redo-conversion-hsa-common/payout-report/payout-report-fields";
import * as z from "zod";

/**
 * Replaces the team's payout report switch, recipients, and column selection.
 * The report sends only when it is on and at least one recipient is listed;
 * on with no recipients is a valid, inactive state. Rejects more than the recipient cap, a
 * malformed address, an unknown column, or an empty selection. Answers with
 * the `HSA_GALE_ORGANIZATION_NOT_LINKED` conflict when the store has no Gale
 * organization yet, so the page can explain why nothing will be sent.
 */
export const updateHsaPayoutReportSettings = {
  name: "updateHsaPayoutReportSettings" as const,
  input: hsaPayoutReportSettingsSchema,
  output: z.null(),
};
